import type { FC } from 'react';
import { Table } from 'reactstrap';
import EmbedYoutube from '../../utils/EmbedYoutube/EmbedYoutube';
import { DataTypesWrapper } from './DataTypes.styled';

interface DataTypesProps {}

const DataTypes: FC<DataTypesProps> = () => (
 <DataTypesWrapper>
   <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">Datatypes</h1>			
   </header>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <p className="text-align-justify">A data type is an attribute of data that tells the compiler how the programmer intends to use the data; in other words, in which format the computer will store the data.</p>
      <br/>
      <EmbedYoutube videoType="video" videoList={["EjoWkBttAWE"]} />
      <br />
      <h6 className="text-align-justify">Types of data types in Java:</h6>

      <ul className="text-align-justify">
         <li><strong>Primitive data types:</strong> The primitive data types consist of boolean, char, byte, short, int, long, float, and double.</li>
         <li><strong>Non-primitive data types:</strong> The non-primitive data types consist of String, Classes, Interfaces, and Arrays.</li>
      </ul>
      <br/>
      <h6 className="text-align-justify">Here’s a list of all primitive data types :</h6>

      <Table bordered striped responsive>
         <thead>
            <tr>
               <th className="text-align-center"><strong>Datatype</strong></th>
               <th className="text-align-center"><strong>Bytes</strong></th>
               <th className="text-align-center"><strong>Bits</strong></th>
               <th className="text-align-center"><strong>Range</strong></th>
               <th className="text-align-center"><strong>Example</strong></th>
            </tr>
         </thead>
         <tbody>
            <tr>
               <td>Long</td>
               <td>8</td>
               <td>64</td>
               <td>-2<sup>63&nbsp;</sup>to 2<sup>63</sup>-1</td>
               <td>long n = 6500000L;</td>
            </tr>
            <tr>
               <td>Int</td>
               <td>4</td>
               <td>32</td>
               <td>-2<sup>31&nbsp;</sup>to 2<sup>31</sup>-1</td>
               <td>int n = 5000000;</td>
            </tr>
            <tr>
               <td>Short</td>
               <td>2</td>
               <td>16</td>
               <td>-2<sup>15&nbsp;</sup>to 2<sup>15</sup>-1</td>
               <td>short n = 10000;</td>
            </tr>
            <tr>
               <td>Byte</td>
               <td>1</td>
               <td>8</td>
               <td>-2<sup>7&nbsp;</sup>to 2<sup>7</sup>-1</td>
               <td>byte n = 90;</td>
            </tr>
            <tr>
               <td>Double</td>
               <td>8</td>
               <td>64</td>
               <td>Precision = 15 digits</td>
               <td>double n = 15.7d;</td>
            </tr>
            <tr>
               <td>Float</td>
               <td>4</td>
               <td>32</td>
               <td>Precision = 6-7 digits</td>
               <td>float n = 4.68f;</td>
            </tr>
            <tr>
               <td>Char</td>
               <td>2</td>
               <td>16</td>
               <td>0 to 2<sup>16</sup>-1</td>
               <td>char c = ‘A’;<br />char c = 67;</td>
            </tr>
            <tr>
               <td>Boolean</td>
               <td>1</td>
               <td>&nbsp;–</td>
               <td>True/false</td>
               <td>boolean isFunny = true;</td>
            </tr>
         </tbody>
      </Table>

      <p className="text-align-justify">Note: Following is the ASCII code for some common characters:<br />0-9 char = ASCII (0-9)<br />A-Z char = ASCII (65-90)<br />a-z char = ASCII (97-122)</p>
      <h6 className="text-align-justify">Here’s a list of non-primitive data types:</h6>

      <Table bordered striped responsive className="custom-table">
         <thead>
            <tr>
               <th className="text-align-center"><strong>String</strong></th>
               <th className="text-align-center"><strong>Class</strong></th>
               <th className="text-align-center"><strong>Interface</strong></th>
               <th className="text-align-center"><strong>Array</strong></th>
            </tr>
         </thead>
         <tbody>
            <tr>
               <td>A String stores a sequence of characters that can also contain spaces and numbers surrounded by double quotes.<br /></td>
               <td>A Class is like a template that is used to create and define&nbsp;objects, object data types, and&nbsp;methods.</td>
               <td>An interface is a reference type that&nbsp;a class implements, thereby inheriting the abstract methods of the&nbsp;interface.</td>
               <td>An Array is treated as an object of fixed size which contains elements of a similar&nbsp;data type.</td>
            </tr>
            <tr>
               <td>An object that contains multiple methods is basically a String. For instance, method to find its length, converting to upper or lower case, trimming text or replacing text.</td>
               <td>The declaration of a class consist of access modifiers, class name, keyword and the body. It allows you to declare a variable along with its data type.</td>
               <td>It consist of methods and variables, but the methods declared are abstract(In other words, method with no body, only signature) by default in an&nbsp;interface.</td>
               <td>We can declare, instantiate, initialize and traverse an array. Array declaration has two components: the type like primitive or user defined and the name.</td>
            </tr>
            <tr>
               <td>{'String s = “How are you?”;'}</td>
               <td>{'public void class Test {'} <br />{'// class body'} <br/>{'}'}</td>
               <td>{'interface Test {'}<br/>{'public void print();'}<br/>{'}'}</td>
               <td>{'int boxes[];'} <br />{'int[] boxes;'}</td>
            </tr>
         </tbody>
      </Table>
   </div>
</DataTypesWrapper>
);

export default DataTypes;
